export default __webpack_public_path__ + "static/mountains-1aa27d914a69aa26b59e5807af7dc8ff.png";